<template>
  <v-container fluid>
    <v-row justify="center" align="center" class="text-page">
      <v-col class="text-center">
        <h1 class="blog-title">Showcase</h1>
        <p class="blog-subtitle">Coming Soon!</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ShowcaseView",
};
</script>

<style scoped></style>
